export default (axios) => ({
    generateLink: (data) => axios.post('/loyalty/generate-link', data).then((_) => _.data),
    getBrands: (params) => axios.get('/loyalty/brands', { params }).then((_) => _.data),
    getProducts: (params) => axios.get('/loyalty/products', { params }).then((_) => _.data),
    getProduct: (id) => axios.get(`/loyalty/products/${id}`).then((_) => _.data),
    exchangeGift: (data) => axios.post('/loyalty/transaction/voucher', data).then((_) => _.data),
    getHistory: (params) => axios.get('/loyalty/histories', { params }).then((_) => _.data),
    getWallet: (params) => axios.get('/loyalty/wallets', { params }).then((_) => _.data),
});
